export default __webpack_public_path__ + "static/media/campaginOff.f9ac518c.svg";